import api from '../../../services/api';

// Helper function to handle API errors
const handleApiError = (error, defaultMessage = 'An error occurred') => {
  console.error('API Error:', error);
  const errorMessage = error.response?.data?.message || 
                     error.message || 
                     defaultMessage;
  throw new Error(errorMessage);
};

// Get all appraisals
export const getAppraisals = async (params = {}) => {
  try {
    const response = await api.get('/appraisals', { params });
    return {
      data: response.data.data || response.data, // Handle both paginated and direct responses
      meta: response.data.meta
    };
  } catch (error) {
    return handleApiError(error, 'Failed to fetch appraisals');
  }
};

// Get a single appraisal by ID
export const getAppraisal = async (id) => {
  try {
    const response = await api.get(`/appraisals/${id}`);
    console.log('Appraisal API Response:', response.data); // Debug log
    return response.data;
  } catch (error) {
    console.error(`Error fetching appraisal ${id}:`, error);
    throw error;
  }
};

// Create a new appraisal
export const createAppraisal = async (appraisalData) => {
  try {
    const response = await api.post('/appraisals', appraisalData);
    return response.data;
  } catch (error) {
    console.error('Error creating appraisal:', error);
    throw error;
  }
};

// Update an existing appraisal
export const updateAppraisal = async (id, appraisalData) => {
  try {
    const response = await api.put(`/appraisals/${id}`, appraisalData);
    return response.data;
  } catch (error) {
    console.error(`Error updating appraisal ${id}:`, error);
    throw error;
  }
};

// Delete an appraisal
export const deleteAppraisal = async (id) => {
  try {
    const response = await api.delete(`/appraisals/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting appraisal ${id}:`, error);
    throw error;
  }
};

// Get appraisals for a specific employee
export const getEmployeeAppraisals = async (employeeId) => {
  try {
    const response = await api.get(`/employees/${employeeId}/appraisals`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching appraisals for employee ${employeeId}:`, error);
    throw error;
  }
};

// Get appraisals by status
export const getAppraisalsByStatus = async (status) => {
  try {
    const response = await api.get('/appraisals', { params: { status } });
    return response.data;
  } catch (error) {
    console.error(`Error fetching ${status} appraisals:`, error);
    throw error;
  }
};

// Get appraisal statistics
export const getAppraisalStats = async () => {
  try {
    const response = await api.get('/appraisals/stats');
    return response.data;
  } catch (error) {
    console.error('Error fetching appraisal statistics:', error);
    throw error;
  }
};
